import React from 'react';
import {
  GeckoToastService,
  GECKO_CONSTS,
  GeckoModal,
  GeckoModalService,
  GeckoForm,
  GeckoFormField,
} from 'ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import CONSTANTS from 'chat-constants';
import { useSelector } from 'react-redux';

const AiInsightsModal = () => {
  const [accountId, aiInsightsValue] = useSelector((state) => [
    state.appState.loggedInUser['account_id'],
    state.appState.features['ai-insights'],
  ]);

  return (
    <GeckoForm
      initialValues={{ aiInsights: aiInsightsValue }}
      onSubmit={({ aiInsights }) => {
        const endpoint = aiInsights ? 'enable' : 'disable';
        return GeckoRequest.post(
          `/admin/features/${CONSTANTS.FEATURES.FEATURE_AI_INSIGHTS}/${endpoint}`,
          {
            accountId,
          }
        )
          .then(() => {
            new GeckoToastService().success(
              `${aiInsights ? 'Enabled' : 'Disabled'} AI Insights`
            );
            return null;
          })
          .catch(renderError);
      }}
    >
      {({ handleSubmit }) => (
        <GeckoModal
          name="Enable AI Insights"
          btns={[
            {
              name: 'Cancel',
              icon: 'far fa-times',
              type: 'default',
              handler: () => {
                new GeckoModalService().close();
              },
            },
            {
              icon: 'far fa-check-double',
              type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
              name: 'Confirm',
              handler: () => {
                handleSubmit();
                return new GeckoModalService().close();
              },
            },
          ]}
        >
          <GeckoFormField
            fieldType="toggle"
            name="aiInsights"
            label="Show AI Insights"
            description={
              'Enable this feature to see AI generated insights on your conversations and reports. This feature is still in beta and we would love to hear your feedback.'
            }
            containerStyle={{ padding: 0, marginBottom: 0 }}
          />
        </GeckoModal>
      )}
    </GeckoForm>
  );
};

export default AiInsightsModal;
